import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";
import type { DestinationListSearchProps } from "../../store/slices/destinations/types";
import { toHttpFormatStartOfDay } from "../utils/formatDate";

const destinationsBaseUrl = `${baseUrl}/destinations-api`;

export const fetchDestinationListRoute = (params: DestinationListSearchProps) =>
  buildUrl({
    url: [destinationsBaseUrl, "destinations", "search"].join("/"),
    searchParams: { ...params, onDate: toHttpFormatStartOfDay(params.onDate), sort: "name" },
  });

export const fetchDestinationVersionsRoute = (destinationId: number) =>
  buildUrl({
    url: [destinationsBaseUrl, "destinations", destinationId, "versions"].join("/"),
  });

export const fetchDestinationSetsRoute = () =>
  buildUrl({
    url: [destinationsBaseUrl, "destination-sets"].join("/"),
  });

export const fetchAccountsByNameRoute = (params: { name: string; page: number; size: number }) => {
  const { name, page, size } = params;
  const searchSting = `pageable-search?organization.fullName=${name}&page=${page}&size=${size}`;
  return buildUrl({
    url: [baseUrl, "accounts-api", "accounts", searchSting].join("/"),
  });
};

export const createDestinationRoute = () =>
  buildUrl({
    url: [destinationsBaseUrl, "destinations"].join("/"),
  });

export const fetchDestinationByIdRoute = (id: number) =>
  buildUrl({
    url: [destinationsBaseUrl, "destinations", id].join("/"),
  });
